import WarningIcon from '@mui/icons-material/Warning';
import * as React from 'react'

export default { WarningIcon, React }